export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  company: string;
  /** Resultado mensurável exibido em destaque (opcional). */
  result?: string;
}

/**
 * Depoimentos reais de clientes. Enquanto a lista estiver vazia,
 * a seção "Resultados" e o item do menu ficam ocultos.
 */
export const testimonials: Testimonial[] = [];
